var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThemesActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1408_3421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1111 12.4444H2.33333C1.04222 12.4444 0 11.4022 0 10.1111V2.33333C0 1.04222 1.04222 0 2.33333 0H10.1111C11.4022 0 12.4444 1.04222 12.4444 2.33333V10.1111C12.4444 11.4022 11.4022 12.4444 10.1111 12.4444ZM28 10.1111V2.33333C28 1.04222 26.9578 0 25.6667 0H17.8889C16.5978 0 15.5556 1.04222 15.5556 2.33333V10.1111C15.5556 11.4022 16.5978 12.4444 17.8889 12.4444H25.6667C26.9578 12.4444 28 11.4022 28 10.1111ZM12.4444 25.6667V17.8889C12.4444 16.5978 11.4022 15.5556 10.1111 15.5556H2.33333C1.04222 15.5556 0 16.5978 0 17.8889V25.6667C0 26.9578 1.04222 28 2.33333 28H10.1111C11.4022 28 12.4444 26.9578 12.4444 25.6667ZM28 25.6667V17.8889C28 16.5978 26.9578 15.5556 25.6667 15.5556H17.8889C16.5978 15.5556 15.5556 16.5978 15.5556 17.8889V25.6667C15.5556 26.9578 16.5978 28 17.8889 28H25.6667C26.9578 28 28 26.9578 28 25.6667Z",
    fill: "#037A9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1408_3421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemesActive);
export default __webpack_public_path__ + "static/media/Themes_active.1b4f54d682ef7e55141100e35792eacc.svg";
export { ForwardRef as ReactComponent };